/**
 * WelcomePage Component
 *
 * Dead-end landing page for unknown users at `/` with no state.
 * Crown logo, "Royale", "Magic address book" centered.
 * "Get Royale" button pinned at bottom opens LaunchSignupOverlay
 * (header-less: just "Launching soon" + name + contact fields).
 *
 * Also used as post-clear/reset layout with optional "Log in" link.
 */

import { useState } from 'react';
import LaunchSignupOverlay from '../components/Overlay/LaunchSignupOverlay';
import { ButtonRounded } from '../components/UISystem/Buttons/ButtonRounded';
import { logEvent } from '../services/analytics/eventLogger';
import { CROWN_BLACK } from '../styles/brandAssets';

const WelcomePage = ({ showLogIn = false }) => {
  const [showSignupOverlay, setShowSignupOverlay] = useState(false);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#FFFFFF',
      }}
    >
      {/* Branding — centered */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img
          src={CROWN_BLACK}
          alt=""
          style={{
            width: '64px',
            height: '40px',
          }}
        />
        <h1
          style={{
            fontSize: '28px',
            fontWeight: '700',
            color: '#000000',
            marginTop: '20px',
            marginBottom: '0',
          }}
        >
          Royale
        </h1>
        <p
          style={{
            fontSize: '15px',
            color: '#8E8E93',
            marginTop: '12px',
            marginBottom: '0',
          }}
        >
          Magic address book
        </p>
      </div>

      {/* Button — pinned to bottom, matching overlay card padding (24px) */}
      <div
        style={{
          paddingBottom: '48px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <ButtonRounded
          text="Get Royale"
          onClick={() => setShowSignupOverlay(true)}
          size="large"
          variant="primary"
        />

        {showLogIn && (
          <a
            href="/signup"
            style={{
              fontSize: '14px',
              color: '#8E8E93',
              textDecoration: 'none',
              cursor: 'pointer',
            }}
          >
            Log in
          </a>
        )}
      </div>

      <LaunchSignupOverlay
        show={showSignupOverlay}
        onClose={() => setShowSignupOverlay(false)}
        onComplete={({ contactType, name }) => {
          setShowSignupOverlay(false);
          const dedupKey = 'analytics_signup_waitlist_welcome';
          if (!localStorage.getItem(dedupKey)) {
            localStorage.setItem(dedupKey, 'true');
            // No contactValue in analytics — client-readable table; the contact
            // lives in the locked launch_waitlist row (see logFunnelSignupWaitlist)
            logEvent('funnel_signup_waitlist', {
              source: showLogIn ? 'post_clear' : 'welcome',
              contactType,
              anonName: name,
              chatRoomId: null,
              connectedWith: null,
              location: null,
            });
          }
        }}
        startAtStage={1}
        hideHeader
      />
    </div>
  );
};

export default WelcomePage;
